import { makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import helpers from 'helpers'

const styles = (isCompact) =>
  makeStyles((theme) => {
    const { watch } = useFormContext()
    const { fontFamily, primaryColor } =
      helpers.cookies.banner.getStyleTokens(watch)

    return {
      globalTypography: {
        fontSize: isCompact ? 12 : 14,
        fontFamily: fontFamily,
        width: 'fit-content',
        color: primaryColor,
      },
      descriptionClamped: {
        width: '100%',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 6,
        overflow: 'hidden',
      },
      descriptionExpanded: {
        width: '100%',
        maxHeight: 120,
        overflowY: 'auto',
      },
      descriptionFade: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 32,
        pointerEvents: 'none',
        backgroundImage: `linear-gradient(to bottom, ${helpers.palette.hexToRgba(
          theme.palette.white,
          0,
        )}, ${theme.palette.white})`,
      },
    }
  })

export default styles
